export default __webpack_public_path__ + "static/Mockup_WeddingDuel-7b8f5d7e56fd3ec2b0c0d308da9f3c45.png";